<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.customPrinting') }}</h3>
    <div class="fabric-library-content">
      <div class="filters f--c">
        <el-select v-model="filters.colorEns" multiple collapse-tags size="mini" filterable placeholder="Search Color" clearable @change="handleSearchInput" style="width:220px;flex-shrink: 0;">
          <el-option
            v-for="item in colorList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
        <el-input v-model.trim="filters.searchContent" clearable size="mini" placeholder="search" style="width: 300px;" @change="handleSearchInput">
          <el-button slot="append" icon="el-icon-search" @click="handleSearchInput"></el-button>
        </el-input>
      </div>
      <div class="fabric-library-box">
        <div class="fabric-library-list f">
          <div v-for="item in list" :key="item.id" class="fabric-item">
            <div class="img pointer" @click="jump(item.imageUrl)">
              <oss-img :src="item.imageUrl" :width="300" />
            </div>
            <div class="name ellipsis" :title="item.printCode"><span class="category">Style#:</span> {{item.printCode}}</div>
            <div class="name ellipsis" :title="item.colorEn"><span class="category">Color:</span> {{item.colorEn}}</div>
          </div>
        </div>
        <div v-if="list.length === 0" style="text-align:center;">No Data</div>
      </div>
      <div style="text-align:right;margin-top:10px" class="bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          :current-page.sync="filters.pageNumber"
          :page-size="filters.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      filters: {
        // searchContent: '',
        pageSize: 20,
        pageNumber: 1
      },
      list: [],
      total: 0,
      colorList: []
    }
  },
  created() {
    this.getPrintPermissionData()
    this.getPrints()
  },
  methods: {
    getPrints() {
      let params = _.cloneDeep(this.filters)
      if (params.searchContent && params.searchContent.includes(',')) {
        params.searchContents = params.searchContent.split(',')
        params.searchContent = undefined
      }
      API.getPrints(params).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    getPrintPermissionData() {
      API.getPrintPermissionData().then(res => {
        this.colorList = res.data
      })
    },
    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.getPrints()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.getPrints()
    },
    handleSearchInput() {
      this.pageCurrentChange(1)
    },
    jump(url) {
      // 跳转到 nuxt商城 界面中
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}
.fabric-library-content {
  background-color: #fff;
  padding: 16px 10px 10px 16px;
  .filters {
    margin-bottom: 10px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
    /deep/ .el-cascader__tags .el-tag {
      max-width: 110px !important;
    }
  }

  .fabric-library-box {
    height: calc(100vh - 220px);
    padding-right: 10px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  .fabric-library-list {
    flex-wrap: wrap;
    .fabric-item {
      width: calc((100% - 40px) / 5);
      height: 100%;
      margin-right: 10px;
      padding-bottom: 16px;
      .img {
        width: 100%;
        aspect-ratio: 1 / 1;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
      .name {
        font-size: 15px;
        margin: 6px 0;
      }
      .category {
        font-size: 13px;
        color: #606266;
        margin-bottom: 3px;
      }
    }
  }
}
</style>
